/* AP Product page enhancements — injects a trust strip below the
   add-to-cart button. Runs once. */
(function () {
  "use strict";

  if (window.__apPdp) return;
  window.__apPdp = true;

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1.5"/><path d="M14 9h4l3 4v4h-7z"/><circle cx="6" cy="19" r="2"/><circle cx="17.5" cy="19" r="2"/></svg>',
    lock:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="11" width="17" height="10" rx="2"/><path d="M7 11V8a5 5 0 0 1 10 0v3"/></svg>',
    refresh: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 4 3 10 9 10"/><polyline points="21 20 21 14 15 14"/><path d="M20 9a8 8 0 0 0-14-3l-3 4M3 15a8 8 0 0 0 14 3l3-4"/></svg>',
    chat:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-11.6 7.1L3 21l1.9-6.4A8 8 0 1 1 21 12z"/></svg>'
  };

  var TRUST = [
    { icon: 'truck',   label: 'Same-Day Delivery' },
    { icon: 'lock',    label: 'Secure Checkout' },
    { icon: 'chat',    label: 'Friendly Support' }
  ];

  function buildStrip() {
    var wrap = document.createElement('div');
    wrap.className = 'ap-pdp-trust';
    wrap.setAttribute('aria-label', 'Customer guarantees');
    TRUST.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'ap-pdp-trust__item';
      var icon = document.createElement('span');
      icon.className = 'ap-pdp-trust__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = ICONS[item.icon] || '';
      var label = document.createElement('span');
      label.textContent = item.label;
      row.appendChild(icon);
      row.appendChild(label);
      wrap.appendChild(row);
    });
    return wrap;
  }

  function inject() {
    var pdp = document.querySelector('.product-page-section');
    if (!pdp || pdp.querySelector('.ap-pdp-trust')) return;
    /* Try the most-likely anchors in order — buy box buttons first */
    var anchor =
      pdp.querySelector('.product-form__buttons') ||
      pdp.querySelector('.product__buttons') ||
      pdp.querySelector('product-form') ||
      pdp.querySelector('[name="add"]')?.closest('form');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildStrip(), anchor.nextSibling);
  }

  /* --- Description Read-more / Read-less --- */
  function setupReadMore() {
    /* Description is now server-rendered as a full-width band:
       <section.ap-pdp-desc-section> .ap-pdp-desc-inner > .ungroup-description-tab
       Attach the clamp + toggle to the body div inside that wrapper. */
    var candidates = [];
    document.querySelectorAll('.ap-pdp-desc-section .ungroup-description-tab .body2').forEach(function (el) { candidates.push(el); });
    candidates.forEach(function (desc) {
      if (desc.dataset.apReadMoreInit) return;
      var threshold = 360;
      var natural = desc.scrollHeight;
      if (natural <= threshold + 60) return;
      desc.dataset.apReadMoreInit = '1';
      desc.setAttribute('data-ap-clamp', '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ap-pdp-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML =
        '<span data-rm-show>Read more</span>' +
        '<span data-rm-hide hidden>Show less</span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      desc.parentNode.insertBefore(btn, desc.nextSibling);

      btn.addEventListener('click', function () {
        var expanded = desc.hasAttribute('data-expanded');
        if (expanded) {
          desc.removeAttribute('data-expanded');
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('[data-rm-show]').hidden = false;
          btn.querySelector('[data-rm-hide]').hidden = true;
          /* Scroll back so the description top stays visible */
          desc.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
          desc.setAttribute('data-expanded', '');
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('[data-rm-show]').hidden = true;
          btn.querySelector('[data-rm-hide]').hidden = false;
        }
      });
    });
  }

  function bootstrap() {
    inject();
    setupReadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
  } else {
    bootstrap();
  }
  /* Re-run if Shopify re-renders the section in the editor */
  document.addEventListener('shopify:section:load', bootstrap);
})();
